import type { Ingredient, Pagination } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'core/ingredients';

export function getIngredients(query: Ingredient.SearchQuery) {
    return api.get<Pagination<Ingredient>>(rootPath, query);
}

export function getIngredient(id: number) {
    return api.get<Ingredient.DetailsResponse>(`${rootPath}/${id}`, undefined);
}

export function postIngredient(data: Ingredient.CreateRequest) {
    return api.post<Ingredient>(rootPath, data);
}

export function putIngredient(id: number, data: Ingredient.UpdateRequest) {
    return api.put<Ingredient>(`${rootPath}/${id}`, data);
}

export function deleteIngredient({ id }: Ingredient.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
